import Checkbox from '@material-ui/core/Checkbox'
import React from 'react'
import { ColumnInstance, MetaBase } from 'react-table'

/**
 * Plugin to add a checkbox column at the beginning of the table.
 * This will always be sticky.
 */
const checkboxColumn = <TData extends Object>(
    defaultCheckboxColumnWidth: number
) => (columns: ColumnInstance<TData>[], _meta: MetaBase<TData>) => {
    return [
        {
            Header: ({ getToggleAllRowsSelectedProps }) => (
                <div>
                    <Checkbox
                        {...getToggleAllRowsSelectedProps({
                            style: { padding: 'unset', color: '#ffffff' },
                        })}
                        className="checkbox-column-header"
                        color="primary"
                        size="small"
                    />
                </div>
            ),
            id: 'checkboxCol',
            groupByBoundary: true,
            disableResizing: true,
            disableSortBy: true,
            disableFilters: true,
            sticky: 'left',
            stickyLeftMargin: 0,
            actionColumn: true,
            maxWidth: defaultCheckboxColumnWidth,
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Checkbox
                            {...row.getToggleRowSelectedProps({
                                style: { padding: 'unset' },
                            })}
                            className="checkbox-column-cell"
                            color="primary"
                            size="small"
                        />
                    </div>
                )
            },
        },
        ...columns,
    ] as ColumnInstance<TData>[]
}

export default checkboxColumn
